// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Merriweather_c59aa5', '__Merriweather_Fallback_c59aa5'","fontStyle":"normal"},"className":"__className_c59aa5","variable":"__variable_c59aa5"};